export default __webpack_public_path__ + "static/media/anchal.726830ce.jpg";